import m from 'mithril';
import {trans} from "../helpers";

let challenge_state = require('../new_challenge_creator/challengeState.js');

class Steps {
    view(){
        let select_exercise_state = '';
        let create_challenge_state = '';
        let visibility_state = '';

        if (challenge_state.current_step == 'select_exercises') {
            select_exercise_state = '.timeline__item--active';
            create_challenge_state = '';
            visibility_state = '';
        }
        if (challenge_state.current_step == 'create_challenge') {
            select_exercise_state = '.timeline__item--past';
            create_challenge_state = '.timeline__item--active';
            visibility_state = '';
        }
        if (challenge_state.current_step == 'challenge_visibility') {
            select_exercise_state = '.timeline__item--past';
            create_challenge_state = '.timeline__item--past';
            visibility_state = '.timeline__item--active';
        }

        return [
            m('div.timeline.timeline--numbered', [
                m('div.timeline__container', [
                    m('div.timeline__item' + select_exercise_state, 
                        {
                            onclick: e => {
                                if(challenge_state.current_step=='create_challenge' || challenge_state.current_step=='invite_friends') 
                                    challenge_state.current_step='select_exercises'
                            }
                        }, 
                        [ 
                            m('div.timeline__item__marker', ''),
                            m('div.timeline__item__texts', [
                                m('div.timeline__item__title', trans('challenge.steps.select_exercise'))
                            ]),
                        ]
                    ),
                    m('div.timeline__item' + create_challenge_state, 
                        {
                            onclick: e => {
                                if(challenge_state.current_step=='invite_friends') 
                                    challenge_state.current_step='create_challenge'
                            }
                        },
                        [ 
                            m('div.timeline__item__marker', ''),
                            m('div.timeline__item__texts', [
                                m('div.timeline__item__title', trans('challenge.steps.details'))
                            ]),
                        ]
                    ),
                    m('div.timeline__item' + visibility_state, [
                        m('div.timeline__item__marker', ''),
                        m('div.timeline__item__texts', [
                            m('div.timeline__item__title', trans('challenge.steps.challenge_visibility'))
                        ]),
                    ]),
                ]),
            ])
        ]
    }
}

export default Steps;